import {
  SET_AUTHENTICATED,
  PENDING_DATA,
  SET_UNAUTHENTICATED,
  LINE_CHARTDATA,
  BAE_CHARTDATA,
  SEAT_BAR_CHARTDATA,
  PIE_DATA,
  ROOM_DATA,
  PARKING_DATA,
  SEAT_BAR_CHARTDATA_PIE,
  TICKETING_DATA,
} from "../type";

const initialState = {
  VisitorChartData: [],
  BarChartData: [],
  SeatBarChart: {},
  SeatBarChartPie: {},
  Pidata: [],
  RoomData: [],
  ParkingData:[],
  PendingData:[],
  Ticketing:[],
  
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_UNAUTHENTICATED:
      return initialState;
    case LINE_CHARTDATA:
      return {
        ...state,
        VisitorChartData: action.payload,
        loading: false,
      };
    case BAE_CHARTDATA:
      return {
        ...state,
        BarChartData: action.payload,
        loading: false,
      };
     
    case SEAT_BAR_CHARTDATA:
      return {
        ...state,
        SeatBarChart: action.payload,
        loading: false,
      };
      case SEAT_BAR_CHARTDATA_PIE:
        return {
          ...state,
          SeatBarChartPie: action.payload,
          loading: false,
        };
    case PIE_DATA:
      return {
        ...state,
        Pidata: action.payload,
        loading: false,
      };
    case ROOM_DATA:
      return {
        ...state,
        RoomData: action.payload,
        loading: false,
      };
      case PARKING_DATA:
      return {
        ...state,
        ParkingData: action.payload,
        loading: false,
      };
      case PENDING_DATA:
        return {
          ...state,
          PendingData: action.payload,
          loading: false,
        };
      case TICKETING_DATA:
      return {
        ...state,
        Ticketing: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
